const INVITATION_TOKEN_PATTERN = /^[A-Za-z0-9_-]{43}$/;

function invitationParams(fragment: string): URLSearchParams {
  return new URLSearchParams(fragment.startsWith('#') ? fragment.slice(1) : fragment);
}

export function readRegistrationInvitation(fragment: string): string | null {
  const token = invitationParams(fragment).get('invite')?.trim();
  return token && INVITATION_TOKEN_PATTERN.test(token) ? token : null;
}

export function removeRegistrationInvitation(fragment: string): string {
  const params = invitationParams(fragment);
  params.delete('invite');
  const remaining = params.toString();
  return remaining ? `#${remaining}` : '';
}

export function removeRegistrationInvitationQuery(search: string): string {
  const params = new URLSearchParams(search);
  params.delete('invite');
  const remaining = params.toString();
  return remaining ? `?${remaining}` : '';
}
